import React, { useState } from 'react';
import { signInWithEmailAndPassword } from '../../constants';
// Custom components
import { DefaultButton } from '../Buttons';
// Material components
import {
    TextField,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
// Styles
import { flex } from '../../assets/jss'
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles({
    footer: {
        ...flex.flex_row_around,
        flexWrap: 'wrap'
    },
    header: {
        textAlign: 'center',
        margin: '12px 0px -12px 0px'
    }
})

const initState = {
    email: '',
    password: ''
}
export default function FormDialog({ switchStatus, handleOpen }) {
    const classes = useStyles();
    const [formData, setFormData] = useState(initState);

    const handleformData = (key, value) => {
        setFormData({ ...formData, [key]: value })
    }

    const handleSubmit = () => {
        signInWithEmailAndPassword(formData.email, formData.password, switchStatus, handleOpen);
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit()
        }
    }

    return (
        <React.Fragment>
            <DialogTitle className={classes.header}>
                Login
            </DialogTitle>
            <DialogContent onKeyPress={handleKeyPress}>
                <TextField
                    margin="dense"
                    id="email"
                    label="Email Address"
                    type="email"
                    fullWidth
                    onChange={(e) => handleformData('email', e.target.value)}
                />
                <TextField
                    margin="dense"
                    id="password"
                    label="Password"
                    type="password"
                    onChange={(e) => handleformData('password', e.target.value)}
                    fullWidth
                />
            </DialogContent>
            <DialogActions className={classes.footer}>
                <DefaultButton
                    onClick={handleSubmit}
                    variant='dark'>
                    Submit
                </DefaultButton>
                <DefaultButton
                    onClick={switchStatus}
                    variant='light'>
                    Subscribe
                </DefaultButton>
            </DialogActions>
        </React.Fragment>
    );
}